module.exports = __webpack_public_path__ + "static/images/gift-list-bg.094a822.png";